export const SectionHeading = ({ eyebrow, title, children, id }) => (
  <div className="wl-section-heading">
    <h2 className="wl-eyebrow" id={id}>{eyebrow}</h2>
    <p className="wl-display">{title}</p>
    {children && <p className="wl-section-intro">{children}</p>}
  </div>
);

export const CareImage = ({ name, alt, caption }) => (
  <figure className={`wl-care-image wl-care-image-${name}`}>
    <img src={`/images/welcome/${name}.webp`} srcSet={`/images/welcome/${name}-small.webp 600w, /images/welcome/${name}.webp 1000w`}
      sizes="(max-width: 767px) calc(100vw - 40px), (max-width: 1100px) 48vw, 620px"
      width="1000" height="671" loading="lazy" decoding="async" alt={alt} data-testid={`welcome-${name}-image`} />
    <figcaption>{caption}<span>AI-generated scene</span></figcaption>
  </figure>
);